var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"credits-page-home"},[_c('div',{staticClass:"credits-page-home-wrap"},[_c('loan-application-status'),(_vm.loanListData)?_c('loan-list'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }